

  import Vue from 'vue'
  import Component from "vue-class-component";
  import {namespace} from "vuex-class";
  import {BoListPanel, BoPanel, IAnyObject, IOnOffHandlers} from "bonomo/dist";
  import PermissionMapDialog from "@/components/settings/permissions/PermissionMapDialog.vue";
  import {Prop, Watch} from "vue-property-decorator";
  import {IUserPermissionLong} from "@/store/modules/user/userPermissionModule";
  import UserChip from "@/components/shared/chips/UserChip.vue";
  import Datim from "@/components/shared/Datim.vue";
  import PermissionTargetChip from "@/components/shared/chips/PermissionTargetChip.vue";
  import {UrlHelper} from "@/helpers/UrlHelper";
  import {BetterDataTableHeader} from "@/model/betterVuetifyInterfaces";

  const permissionsModule = namespace("permissionsModule");
  const userPermissionModule = namespace("userPermissionModule");

  @Component({
    components: {
      BoListPanel,
      BoPanel,
      PermissionMapDialog,
      UserChip,
      Datim,
      PermissionTargetChip,
    }
  })
  export default class WhoHas extends Vue {

    @Prop()
    protected permissionId!: number;

    @permissionsModule.Getter('permissionTargets')
    private permissionTargets!: string[];
    @userPermissionModule.Getter('whoHas')
    protected userPermissions!: IUserPermissionLong[]

    @userPermissionModule.Action('clearWhoHas')
    protected clearWhoHas!: (filters: IAnyObject) => Promise<any>;
    @userPermissionModule.Action('fetchWhoHas')
    protected fetchWhoHas!: (filters: IAnyObject) => Promise<any>;
    @permissionsModule.Action('fetchPermissionTargets')
    protected fetchPermissionTargets!: () => Promise<any>;

    protected UrlHelper: UrlHelper = UrlHelper;
    protected get headers(): BetterDataTableHeader[] {
      return [
        { text: this.$t('users.user.title') + '  ', align: 'start', sortable: true, value: 'user.email' },
        { text: this.$t('users.userPermissions.fields.target'), align: 'start', sortable: true, value: 'target' },
        { text: this.$t('users.userPermissions.fields.granted_by'), align: 'start', groupable: false, value: 'granted_by' },
        { text: this.$t('users.userPermissions.fields.from'), align: 'start', groupable: false, value: 'created_at' },
        { text: '', align: 'end', groupable: false, value: 'control' },
      ];
    }
    protected permissionModel: any = null;
    protected groupBy: string|null = null;
    protected get canGroupBy(): boolean {
      if (!this.permissionId || !this.permissionTargets) {
        return false;
      }
      const permission = this.permissionTargets[this.permissionId];
      return !!permission;
    }

    protected get extraFilters(): IAnyObject {
      // inject permissionId into extraFilters but don't use it as remote-filter-field
      // the change will be taken up from the url change indeed
      return {
        permissionId: this.permissionId,
      };
    }

    get permissionItems() {
      const permissionTargets = this.permissionTargets;

      const ret: any[] = Object.keys(permissionTargets).map((eachKey: string) => {
        return {
          text: eachKey + '. ' + this.$t('settings.permissions.permissions.' + eachKey + '.title'),
          value: eachKey,
        }
      });
      return ret;
    }

    protected onPermissionChanged(newPermissionId: string) {
      this.$router.push({name: 'permissionWhoHas', params: {permissionId: newPermissionId}});
    }

    protected onGroupBy() {
      this.groupBy = '';
      this.groupBy = 'user_id';
    }

    protected onUnGroup(cb: () => any) {
      this.groupBy = '';
      Vue.nextTick(cb);
    }

    private loadData() {
      // this action is debounced so we can just keep calling it
      this.fetchPermissionTargets();
    }

  }
